import MultiSelect from "@/components/MultiSelect";

type GovernanceRoleFilterProps = {
  options: { value: string; label: string }[];
  selectedValues: string[];
  onSelect: (value: string, checked: boolean) => void;
  onClear: () => void;
};

export function GovernanceRoleFilter({ options, selectedValues, onSelect, onClear }: GovernanceRoleFilterProps) {
  if (options.length === 0) {
    return null;
  }

  return (
    <div data-name="role">
      <MultiSelect
        label="Role"
        options={options}
        selectedValues={selectedValues}
        onSelect={onSelect}
        onClear={onClear}
        searchable={options.length > 8}
      />
    </div>
  );
}
